import { getApiUrl } from "../api/client";

function buildTicketsQueryParams() {
  const p = new URLSearchParams();
  p.set("per_page", "50");
  p.set("page", "1");
  p.set("hostname", window.location.hostname || "");
  return p;
}

async function fetchTicketList(queryParam, remoteId) {
  const params = buildTicketsQueryParams();
  params.set(queryParam, String(remoteId));
  const res = await fetch(getApiUrl(`/tickets?${params.toString()}`), {
    method: "GET",
    credentials: "include",
    headers: { "Cache-Control": "no-cache" },
  });
  if (!res.ok) return [];
  const text = await res.text();
  if (!text?.trim()) return [];
  try {
    const data = JSON.parse(text);
    return data.status === "OK" && Array.isArray(data.data) ? data.data : [];
  } catch {
    return [];
  }
}

/**
 * گفت‌وگوهایی که این شخص owner یا assignee آن‌هاست.
 * @param {string|number} remoteId
 * @param {{ excludeTicketId?: string|number|null }} [options]
 */
export async function fetchTicketsWithPerson(remoteId, { excludeTicketId = null } = {}) {
  if (remoteId == null || remoteId === "") return [];

  const excludeId = excludeTicketId != null ? Number(excludeTicketId) : null;
  const byId = new Map();

  const merge = (list) => {
    (Array.isArray(list) ? list : []).forEach((ticket) => {
      if (!ticket?.id) return;
      if (excludeId != null && Number(ticket.id) === excludeId) return;
      byId.set(ticket.id, ticket);
    });
  };

  const [ownerTickets, assigneeTickets] = await Promise.all([
    fetchTicketList("owner_id", remoteId),
    fetchTicketList("assignee_id", remoteId),
  ]);

  merge(ownerTickets);
  merge(assigneeTickets);

  return Array.from(byId.values()).sort(
    (a, b) =>
      new Date(b.updated_at || b.created_at || 0).getTime() -
      new Date(a.updated_at || a.created_at || 0).getTime()
  );
}
